/**
 * Application Configuration
 * 
 * Centralized configuration for API endpoints and other app-wide settings.
 */

// API Base URL - uses relative path for same-origin requests
// For local development: Vite dev server proxies /api to localhost:8004
// For production: use /leadsource/api (proxied through Resource Consents)
export const API_BASE_URL = import.meta.env.DEV 
  ? '/api' 
  : '/leadsource/api';

// App Information
export const APP_NAME = 'Leadforce Manager';
export const APP_VERSION = '1.0.0';

// Pagination Defaults
export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;

// Feature Flags
export const FEATURES = {
  enableRealTimeUpdates: false,
  enableNotifications: false,
  enableDarkMode: false,
};

// Date/Time Formats
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';

// Timeout Settings (in milliseconds)
export const API_TIMEOUT = 30000;
export const DEBOUNCE_DELAY = 300;
